import Table from "../../Utils/Grid";

import React, { Component } from 'react';
import { BreakLine } from '../../Utils/tableOptions';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils, {
    formatDate,
    parseDate,
} from 'react-day-picker/moment';
import CustomToolbar from '../../Utils/Toolbar/CustomToolbar';
import ToolbarSelect from '../../Utils/Toolbar/ToolbarSelect';
import moment from "moment";
import { Link } from 'react-router-dom';
import {RenderCurrency} from "../../Utils/renderField/renderReadField";
import NumberFormat from "react-number-format";
import './general-report.css';
import { IconSpreadSheet } from "../consolidado-gastos/contextConsolidado";
import SearchSelect from "../../Utils/Toolbar/Select";
import { igss_code_options } from "./IGSS_OPTIONS";

const SUPERUSER = 'superuser'; 
class GeneralReportIgss extends Component{
    componentWillUnmount() {
        this.props.resetStore();
    }

    componentWillMount() {
        this.props.getCodeProcedures();
        this.props.listar()
    }

    render() {
        const {
            listar,
            setInitialDate,
            setFinalDate,

            openAccount,
            cancelOpenAccount,
            generarExcelReporteIgss,
            setIgssCode,
            procedure_code
        } = this.props;

        const {
            cargando,
            page,
            data,
            initial_date,
            final_date,
            saldo_total,
            igss_code,
            procedures
        } = this.props;
       
        const options = [            
            {value: 0, label: 'Todas'},
            {value: 1, label: 'Hospitalización'},
            {value: 2, label: 'Consulta externa'},
            {value: 3, label: 'Emergencia'}
        ];

        const REQUEST_ORIGIN = [
            'NINGUNO',
            'HOSPITALIZACION',
            'CONSULTA EXTERNA',
            'EMERGENCIA'
        ]

        const PATIENT_TYPE = [
            '',
            'af',
            'be',
            'bh',
            'pei',
            'jub',
            'je'
        ]

        return (
            <div className="content pt-3">                
                <div className="m-auto row-fluid w-100">
                    <div className="table-decoration">
                        <div className="d-flex flex-row justify-content-around align-items-center">
                        <div className="top-title-toolbar">
                            <ToolbarSelect
                                titulo="Reporte IGSS"
                                buscar={this.props.changeFilter}
                                buscador={this.props.select_search}
                                options={options} 
                                valueKey="value"
                                labelKey="label"
                                autofocus
                                ancho="w-75"
                            />
                        </div>

                        <div className="d-flex flex-row justify-content-end align-items-center w-50">
                            <NumberFormat format="##/##/####" placeholder="DD/MM/YYYY" mask={['D', 'D', 'M', 'M', 'Y', 'Y', 'Y', 'Y']}
                                className="form-control w-20"
                                value={initial_date}
                                onValueChange={(values) => {                                        
                                    const dia = values.formattedValue.indexOf("D")
                                    const mes = values.formattedValue.indexOf("M")
                                    const anio = values.formattedValue.indexOf("Y")

                                    if((dia + mes + anio) < 0){
                                        setInitialDate(values.formattedValue);
                                    }                                                                                
                                }}
                                autoFocus
                                onFocus={(e) => {
                                    e.target.setSelectionRange(0,10);
                                }}                                    
                            />

                            <NumberFormat format="##/##/####" placeholder="DD/MM/YYYY" mask={['D', 'D', 'M', 'M', 'Y', 'Y', 'Y', 'Y']}
                                className="form-control w-20 ml-2 mr-2"
                                value={final_date}
                                onValueChange={(values) => {                                        
                                    const dia = values.formattedValue.indexOf("D")
                                    const mes = values.formattedValue.indexOf("M")
                                    const anio = values.formattedValue.indexOf("Y")

                                    if((dia + mes + anio) < 0){
                                        setFinalDate(values.formattedValue);
                                    }                                                                                
                                }}
                                
                                onFocus={(e) => {
                                    e.target.setSelectionRange(0,10);
                                }}                                    
                            />
                        <div className="top-title-toolbar mt-3">
                            <CustomToolbar
                                buscar={this.props.search}
                                buscador={this.props.buscador}                            
                            />
                        </div>
                        </div>
                        </div>
                    </div>
                    <div className="table-decoration">
                    <table className="table table-sm table-bordered">
                    <tr>
                        <td>
                            <button className="btn btn-success btn-sm" onClick={generarExcelReporteIgss}>
                                <IconSpreadSheet /> Generar Excel
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td>NOMBRE DEL PROVEEDOR: PROLASER GUATEMALA S.A.</td>
                        <td>NIT: 6769142-0</td>
                        <td>
                            CODIGO IGSS: 
                            
                            <SearchSelect
                                options={procedures}
                                valueKey="value"
                                labelKey="label"                                
                                buscar={setIgssCode} 
                                buscador={igss_code}
                                autofocus={this.props.autofocus}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td style={{ alignItems: 'center' }}>
                        FACTURACION CORRESPONDIENTE AL PERIODO DE:
                        </td>
                        <td>                             
                            {initial_date}
                        </td>
                        <td>
                           {final_date}                       
                        </td>                                             
                    </tr>
                    <tr>                        
                        <td colSpan={3}>
                            MONTO TOTAL DE FACTURA CON IVA: Q{parseFloat(saldo_total).toFixed(2)}
                        </td>
                    </tr>
                </table>
                <table className="table table-sm table-bordered general-report-igss">
                    <thead>
                        <tr>
                            <th className="general-report-igss" rowSpan={2}>No.</th>
                            <th className="general-report-igss" rowSpan={2}>Nombre completo del paciente</th>
                            <th className="general-report-igss" rowSpan={2}>Afiliación</th>
                            <th className="general-report-igss" rowSpan={2}>Nombre del estudio o procedimiento</th>
                            <th className="general-report-igss" rowSpan={2}>Origen del estudio</th>
                            <th className="general-report-igss" rowSpan={2}>Código IGSS</th>
                            <th className="general-report-igss" colSpan={2}>Formulario SPS-465</th>
                            <th className="general-report-igss"></th>
                            <th  className="general-report-igss" rowSpan={2}>Fecha de estudio o procedimiento</th>
                            <th  className="general-report-igss" rowSpan={2}>Valor unitario con IVA</th>
                        </tr>
                        <tr>
                            <th className="general-report-igss">Número</th>
                            <th className="general-report-igss">Fecha</th>                            
                        </tr>                        
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <tr>
                                <td>{index + 1}</td>                                
                                <td> 
                                    {item.patient &&
                                        <React.Fragment>
                                            {item.patient.first_name} {item.patient.last_name}
                                        </React.Fragment>
                                    }                                    
                                </td>
                                <td>
                                    {item.patient &&
                                        <React.Fragment>
                                            {/*item.patient.no_afiliacion && `${PATIENT_TYPE[item.patientType]} `} {item.patient.no_afiliacion*/}
                                            {item.patient.no_afiliacion && `${item.patient.no_afiliacion}`}
                                        </React.Fragment>
                                    }
                                </td>
                                <td>
                                    {item.procedure &&
                                        <React.Fragment>
                                            {item.procedure.name}
                                        </React.Fragment>
                                    }
                                </td>
                                <td>
                                    {REQUEST_ORIGIN[item.requestOrigin]}                                    
                                </td>
                                <td>
                                    {procedure_code}
                                </td>
                                <td>
                                    {item.no}
                                </td>
                                <td colSpan={2}>
                                    {item.formDate}
                                </td>
                                <td>
                                    {item.procedureDate}
                                </td>   
                                <td>
                                    {item.procedure &&
                                        <React.Fragment>
                                        Q{item.procedure.price}
                                        </React.Fragment>
                                    }
                                </td> 
                            </tr>
                        ))}
                        <tr>
                            <th className="general-report-igss" colSpan={10}>Total</th>
                            <td
                                style={{ fontWeight: 700 }}
                            >Q{parseFloat(saldo_total).toFixed(2)}</td>
                        </tr>
                    </tbody>
                </table>  
                </div>                  
                </div>                
                {/*
                <div className="m-auto row-fluid w-100">
                    <div className="table-decoration">


                    <div className="d-flex flex-row justify-content-around align-items-center">
                    <div className="top-title-toolbar">
                        <ToolbarSelect 
                            titulo="CUENTAS ABIERTAS IGSS"
                            buscar={this.props.changeFilter}
                            buscador={this.props.select_search}
                            options={options} 
                            valueKey="value"
                            labelKey="label"
                            autofocus
                            ancho="w-75"
                        />
                    </div>

                    <div className="d-flex flex-row justify-content-end align-items-center w-50">
                        <NumberFormat format="##/##/####" placeholder="DD/MM/YYYY" mask={['D', 'D', 'M', 'M', 'Y', 'Y', 'Y', 'Y']}
                            className="form-control w-20"
                            value={initial_date}
                            onValueChange={(values) => {                                        
                                const dia = values.formattedValue.indexOf("D")
                                const mes = values.formattedValue.indexOf("M")
                                const anio = values.formattedValue.indexOf("Y")

                                if((dia + mes + anio) < 0){
                                    setInitialDate(values.formattedValue);
                                }                                                                                
                            }}
                            autoFocus
                            onFocus={(e) => {
                                e.target.setSelectionRange(0,10);
                            }}                                    
                        />

                        <NumberFormat format="##/##/####" placeholder="DD/MM/YYYY" mask={['D', 'D', 'M', 'M', 'Y', 'Y', 'Y', 'Y']}
                            className="form-control w-20 ml-2 mr-2"
                            value={final_date}
                            onValueChange={(values) => {                                        
                                const dia = values.formattedValue.indexOf("D")
                                const mes = values.formattedValue.indexOf("M")
                                const anio = values.formattedValue.indexOf("Y")

                                if((dia + mes + anio) < 0){
                                    setFinalDate(values.formattedValue);
                                }                                                                                
                            }}
                            
                            onFocus={(e) => {
                                e.target.setSelectionRange(0,10);
                            }}                                    
                        />
                    <div className="top-title-toolbar mt-3">
                        <CustomToolbar
                            buscar={this.props.search}
                            buscador={this.props.buscador}                            
                        />
                    </div>
                    <div className='font-weight-bold ml-3 d-flex flex-row' style={{fontSize: 16}}>
                        Total:&nbsp;<RenderCurrency value={saldo_total} />
                    </div>
                    </div>
                    </div>
                    </div>
                </div>
                */}
            </div>
        )
    }
}

export default GeneralReportIgss;